<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-23 16:23:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-26 11:33:44
 * @Description: 开关式单选
 * @FilePath: /hsylc2021/src/components/form/RadioTrigger/index.vue
-->
<template>
  <div class="component-radio-trigger" :class="computedClass">
    <div
      class="component-item"
      v-for="(item, index) in options"
      :key="index"
      :style="{ width: itemWidth }"
      :class="getItemClass(item)"
      @click="handleClickItem(item)"
    >
      <div class="item-text w-bold">{{ item.label }}</div>
    </div>
  </div>
</template>
<script>
/**
 * 切换式radio
 * @module RadioTrigger
 */
export default {
  name: 'RadioTrigger',
  /**
   * @prop {String} className 外部class
   * @prop {Array} options 选项列表 { label: 'xxx', value: 'xxx' }
   * @prop {String} size 大小 normal 默认normal
   * @prop {Object} value 数据
   * @prop {Boolean} disabled 是否禁止 默认false
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    size: {
      type: String,
      default: 'normal'
    },
    value: {
      type: Object,
      default: function() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  /**
   * @prop {Object} computedClass 计算class
   * @prop {String} itemWidth 计算后的百分比item宽度
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret[this.size] = true;
      ret['disabled'] = this.disabled;
      return ret;
    },
    itemWidth() {
      let ret = '100%';
      if (this.options && this.options.length) {
        ret = `${100 / this.options.length}%`;
      }
      return ret;
    }
  },
  methods: {
    /**
     * @description 计算item class
     * @function getItemClass
     * @param {Object} item options item数据
     * @return {Object} class对象
     */
    getItemClass: function(item) {
      let ret = {};
      if (this.value && this.value.value === item.value) {
        ret['active'] = true;
      }
      return ret;
    },
    /**
     * @event input v-model绑定事件
     */
    /**
     * @description 点击选项事件
     * @function handleClickItem
     * @param {Object} item options item数据
     */
    handleClickItem: function(item) {
      if (!this.disabled) {
        this.$emit('input', item);
      }
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
